export const encode = (value: string): string => btoa(value)
export const decode = (value: string): string => atob(value)

export const validateCrypto = (): void => {
  if (!getCrypto()) {
    throw new Error('For security reasons, `window.crypto` is required to run `spreadthemusic-spa-js`.')
  }
  if (typeof getCryptoSubtle() === 'undefined') {
    throw new Error('spreadthemusic-spa-js must run on a secure origin.')
  }
}

export const getCrypto = (): Crypto => {
  const crypto = (window.crypto || (window as any).msCrypto) as Crypto

  return crypto
}

export const getCryptoSubtle = (): SubtleCrypto => {
  const crypto = getCrypto()
  const cryptoSubtle = crypto.subtle || (crypto as any).webkitSubtle

  return cryptoSubtle
}

export const createRandomString = (len = 43): string => {
  const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.'
  let random = ''
  const randomValues = Array.from(getCrypto().getRandomValues(new Uint8Array(len)))
  randomValues.forEach((v) => (random += charset[v % charset.length]))
  return random
}

export const createQueryParams = (params: any): string | undefined => {
  return Object.keys(params)
    .filter((k) => typeof params[k] !== 'undefined')
    .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&')
}

// eslint-disable-next-line space-before-function-paren
export const sha256 = async (message: string): Promise<string> => {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message)

  try {
    // hash the message
    const hashBuffer = await getCryptoSubtle().digest('SHA-256', msgBuffer)

    // convert ArrayBuffer to Array
    const base64String = btoa(new Uint8Array(hashBuffer).reduce((data, byte) => data + String.fromCharCode(byte), ''))
    return base64String
  } catch (e) {
    console.error(e)
    return btoa(message)
  }
}

export const removeTrailingSlash = (path?: string): string => {
  if (!path) {
    return ''
  }
  // Remove any whitespace before or after string
  let trimmed = path.replace(/^\s+|\s+$/gm, '')
  // Remove trailing slash(es)
  trimmed = trimmed.replace(/\/+$/, '')

  return trimmed
}
